export const AT_MENTION_CATEGORIES = [
  { id: 'users', label: 'Users' },
  { id: 'access-groups', label: 'Access groups' },
  { id: 'credentials', label: 'Credentials' },
  { id: 'devices', label: 'Devices' },
  { id: 'schedules', label: 'Schedules' },
] as const;

export const AT_MENTION_TEMPLATE_TOKENS = [
  { token: 'user', label: '@user', subtitle: 'Person in the system' },
  { token: 'device', label: '@device', subtitle: 'Controller or reader' },
  { token: 'access-group', label: '@access-group', subtitle: 'Access group' },
  { token: 'schedule', label: '@schedule', subtitle: 'Time schedule' },
  { token: 'credential', label: '@credential', subtitle: 'Card or PIN' },
] as const;

export type AtMentionEntity = {
  id: string;
  name: string;
  subtitle: string;
};

/** Bootstrap users for @mentions; extended at runtime via user registry. */
export const AT_MENTION_SEED_USERS: AtMentionEntity[] = [
  { id: 'seed-1', name: 'Arjun', subtitle: 'Viewers' },
  { id: 'seed-2', name: 'Ramesh', subtitle: 'Operators' },
  { id: 'seed-3', name: 'Swathi', subtitle: 'Viewers' },
];

export const AT_MENTION_ENTITIES: Record<string, AtMentionEntity[]> = {
  users: AT_MENTION_SEED_USERS,
  'access-groups': [
    { id: '1', name: 'Floor 1 Access', subtitle: 'Access Group' },
    { id: '2', name: 'Admin Access', subtitle: 'Access Group' },
  ],
  credentials: [
    { id: '1', name: 'Card #1042', subtitle: 'HID Card' },
    { id: '2', name: 'Card #2011', subtitle: 'Wiegand' },
  ],
  devices: [
    { id: '1', name: 'Front Door Controller', subtitle: 'Panel' },
    { id: '2', name: 'Server Room Reader', subtitle: 'Reader' },
  ],
  schedules: [
    { id: '1', name: 'Business Hours', subtitle: 'Mon-Fri 9-5' },
    { id: '2', name: '24/7 Access', subtitle: 'Always' },
  ],
};

